var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import sanitizeHtml from 'sanitize-html';
import { SanitizeHTML } from 'app/utils/htmlSanitizer';
/**
 * @todo This is just for the Highlight component; when highlighting is done
 *   with React components (TEAMS-5265), we should use only SANITIZE_PROFILE.
 */
export const sanitizeProfiles = Object.assign(Object.assign({}, SanitizeHTML.profiles), { highlight: {
        allowedTags: ['em'],
        allowedClasses: {
            em: ['highlight'],
        },
    } });
export const SafeInnerHtmlSetter = (_a) => {
    var { element, content, profile, noSanitize, innerRef } = _a, otherProps = __rest(_a, ["element", "content", "profile", "noSanitize", "innerRef"]);
    const sanitizationProfile = profile
        ? sanitizeProfiles[profile]
        : sanitizeProfiles.default;
    return React.createElement(element, Object.assign(Object.assign({}, otherProps), { ref: innerRef, dangerouslySetInnerHTML: {
            __html: noSanitize ? content : sanitizeHtml(content, sanitizationProfile),
        } }));
};
